<nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <ul class="navbar-nav">
        <li class="nav-item">
            <a class="nav-link" (click)="toggleMenuSidebar.emit()" role="button"
                ><i class="fas fa-bars"></i
            ></a>
        </li>
        <!-- <li class="nav-item d-none d-sm-inline-block">
            <a [routerLink]="['/']" class="nav-link">Home</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
            <a [routerLink]="['/contact']" class="nav-link">Contact</a>
        </li> -->
        <li>
            
        </li>
    </ul>
    <!-- <div class="row">
        <div class="col"><h3 style="margin-left: 150px;">Food Safety on <span>Wheels</span></h3></div>
    </div>
    <div class="row">
        <div class="col"><p>A Food Safety and Standards Authority of India (FSSAI) Initiative </p></div>
        </div> -->
    
    <img src="/assets/img/fsw_header1.png" style="width:380px; margin-left: 180px;">
    <form class="form-inline ml-3" [formGroup]="searchForm" *ngIf="false">
        <div class="input-group input-group-sm">
            <input
                class="form-control form-control-navbar"
                type="search"
                placeholder="Search"
                aria-label="Search"
            />
            <div class="input-group-append">
                <button class="btn btn-navbar" type="submit">
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </div>
    </form>

    <ul class="navbar-nav ml-auto">
       <!--  <app-messages></app-messages>
        <app-notifications></app-notifications>
        <app-language></app-language> -->
        <app-user></app-user>
        <!-- <li class="nav-item">
      <a
        class="nav-link"
        data-widget="control-sidebar"
        data-slide="true"
        href="#"
        role="button"
      >
        <i class="fas fa-th-large"></i>
      </a>
    </li> -->
    </ul>
</nav>
